import {Lightbox} from '../../classes/Lightbox';
import NewSlideshow from '../../classes/NewSlideshow';

export const initBanks = () => {
	const bankSections = document.querySelectorAll( 'section.banks' );

	if ( !bankSections.length )
	{
		return;
	}

	let isMobile = window.innerWidth < 636;
	let isMobileViewOn = false;
	let slider = null;

	const rearrangeBanks = ( section, banks ) => {
		isMobile = window.innerWidth < 636;

		if ( isMobile && !isMobileViewOn )
		{
			if ( !slider )
			{
				const slidesCount = Array( Math.floor( banks.length / 6 ) + Number( banks.length % 6 > 0 ) ).fill( '' ).map( () => '<li><ul></ul></li>' ).join( '' );

				section.insertAdjacentHTML( 'afterbegin', `<div class="new-slider"><ul class="slides" data-slider-role="slides">${slidesCount}</ul><ul class="bookmarks" data-slider-role="bookmarks">${slidesCount.replace( /<ul><\/ul>/gu, '' )}</ul></div>` );

				slider = section.querySelector( 'div.new-slider' );

				Array.from( banks ).forEach( ( it, i ) => {
					slider.querySelector( 'ul.slides' ).children[Math.floor( i / 6 )].children[0].append( it.cloneNode( true ) );
				} );

				const sliderInstance = new NewSlideshow( {
					element: slider,
				} );

				sliderInstance.init();

				slider.addEventListener( 'click', ( evt ) => {
					const bank = evt.target.closest( 'li.bank' );

					if ( !bank )
					{
						return;
					}

					const lightboxContent = bank.innerHTML;

					Lightbox.open( lightboxContent, null, 'tooltip' );
				} );
			}

			isMobileViewOn = true;
		}
		else if ( !isMobile && isMobileViewOn )
		{
			isMobileViewOn = false;
		}
	};

	Array.from( bankSections ).forEach( ( it ) => {
		const banks = it.querySelectorAll( 'ul.banks > li' );
		
		rearrangeBanks( it, banks );

		window.addEventListener( 'resize', () => {
			rearrangeBanks( it, banks );
		} );
	} );
};
